import { LineBasicMaterial, MeshBasicMaterial } from 'three';

export const CELL_MAT_NAMES = {
	normal: 'cellMaterial',
	selected: 'cellSelectedMaterial'
};

export class Scene2DMaterials {

	//CELL MATERIAL
	static #cellMaterial = null;
	static get CellMaterial() {
		if (this.#cellMaterial === null) {
			this.#cellMaterial = new MeshBasicMaterial( { color: 0xaaaaaa } );
			this.#cellMaterial.name = CELL_MAT_NAMES.normal;
		}
		
		return this.#cellMaterial;
	}

	static #cellHiddenMaterial = null;
	static get CellHiddenMaterial() {
		if( this.#cellHiddenMaterial === null ) {
			this.#cellHiddenMaterial = new MeshBasicMaterial( { color: 0x000000, transparent: true, opacity: 0 } );
			this.#cellHiddenMaterial.name = 'cellHiddenMaterial';
		}
		return this.#cellHiddenMaterial;
	}
	
	//SELECTED CELL MATERIAL
	static #cellSelectedMaterial = null;
	static get CellSelectedMaterial() {
		if (this.#cellSelectedMaterial === null) {
			this.#cellSelectedMaterial = new MeshBasicMaterial( { color: 0xfc6a03 } );
			this.#cellSelectedMaterial.name = CELL_MAT_NAMES.selected;
		}
		return this.#cellSelectedMaterial;
	}
	
	//CELL LINE MATERIAL
	static #cellLineMaterial = null;
	static get CellLineMaterial() {
		if (this.#cellLineMaterial === null) {
			this.#cellLineMaterial = new LineBasicMaterial( { color: 0x000000 } );
		}
		return this.#cellLineMaterial;
	}
}